import { Routes, Route, Navigate } from 'react-router-dom'
import Login from './routes/Login'
import Dashboard from './routes/Dashboard'
import ContainerDetail from './routes/ContainerDetail'
import Services from './routes/Services'
import ServiceDetail from './routes/ServiceDetail'
import Deploy from './routes/Deploy'
import Domains from './routes/Domains'
import DBViewer from './routes/DBViewer'
import Monitoring from './routes/Monitoring'
import Networks from './routes/Networks'
import Settings from './routes/Settings'
import Jobs from './routes/Jobs'
import Layout from './components/Layout'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route
          path="/containers/:nodeId/:containerId"
          element={<ContainerDetail />}
        />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:id" element={<ServiceDetail />} />
        <Route path="/deploy" element={<Deploy />} />
        <Route path="/domains" element={<Domains />} />
        <Route path="/db" element={<DBViewer />} />
        <Route path="/monitoring" element={<Monitoring />} />
        <Route path="/networks" element={<Networks />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
